import React from 'react';
import _ from 'lodash';

import { Menu } from 'antd';

import { ProductAestheticMotif } from '../../../../../api-client';

import './bv-aesthetic-nav.scss';

import BVShimmer from '../../../../../common/components/BVShimmers/BVShimmer/bv-shimmer';

interface IBVAestheticNav {
    data?: ProductAestheticMotif[];
    dataLoading: boolean;
    dataFilter?: any;
    onClick: (aestheticFilter: any) => void;
}

const BVAestheticNav: React.FunctionComponent<IBVAestheticNav> = ({ data = [], dataLoading, dataFilter, onClick }) => {
    const _handleProductTypeByAestheticCode = (code: string) => {
        if (!code) {
            return undefined;
        }

        const currentAesthetic = _.find(data, entry => entry.code === code);
        if (!currentAesthetic || !currentAesthetic.productTypes || currentAesthetic.productTypes.length === 0) {
            return undefined;
        }

        return currentAesthetic.productTypes[0];
    }

    const _handleSecondaryNav = () => {
        if (!dataFilter.aestheticMotif) {
            return null;
        }

        const currentAesthetic = data.find(entry => entry.code === dataFilter.aestheticMotif);
        if (!currentAesthetic || !currentAesthetic.productTypes || currentAesthetic.productTypes.length === 0) {
            return null;
        }

        return (
            <Menu
                className="bv-aesthetic-nav"
                mode="horizontal"
                selectedKeys={dataFilter.aestheticMotifType ? [dataFilter.aestheticMotifType] : []}
                onClick={(e) => onClick({
                    ...dataFilter,
                    aestheticMotifType: e.key
                })}
            >
                {currentAesthetic.productTypes.map((productType: string) => (
                    <Menu.Item key={productType}>
                        {productType}
                    </Menu.Item>
                ))}
            </Menu>
        );
    }

    return (
        <BVShimmer loading={dataLoading} type={'shimmer-nav'}>
            <Menu
                className="bv-aesthetic-nav"
                mode="horizontal"
                selectedKeys={dataFilter.aestheticMotif ? [dataFilter.aestheticMotif] : []}
                onClick={(e) => onClick({
                    aestheticMotif: e.key,
                    aestheticMotifType: _handleProductTypeByAestheticCode(e.key)
                })}
            >
                {_.map(data, (aesthetic: ProductAestheticMotif) => (
                    <Menu.Item key={aesthetic.code}>
                        {aesthetic.code}
                    </Menu.Item>
                ))}
            </Menu>

            {_handleSecondaryNav()}
        </BVShimmer>
    );
}

export default BVAestheticNav;